module.exports = __webpack_public_path__ + "assets/img/chevron-down@1,5x.1aa30082.svg";